/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'filters': {
    viewBox: '0 0 32 32',
    data: '<path d="M2,8h3.1c0.4,1.7,2,3,3.9,3s3.4-1.3,3.9-3H30c0.6,0,1-0.4,1-1s-0.4-1-1-1H12.9c-0.4-1.7-2-3-3.9-3S5.6,4.3,5.1,6H2C1.4,6,1,6.4,1,7S1.4,8,2,8z"/><path d="M30,24H19.9c-0.4-1.7-2-3-3.9-3s-3.4,1.3-3.9,3H2c-0.6,0-1,0.4-1,1s0.4,1,1,1h10.1c0.4,1.7,2,3,3.9,3s3.4-1.3,3.9-3H30c0.6,0,1-0.4,1-1S30.6,24,30,24z"/><path d="M30,15h-1.1c-0.4-1.7-2-3-3.9-3s-3.4,1.3-3.9,3H2c-0.6,0-1,0.4-1,1s0.4,1,1,1h19.1c0.4,1.7,2,3,3.9,3s3.4-1.3,3.9-3H30c0.6,0,1-0.4,1-1S30.6,15,30,15z M25,18c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C27,17.1,26.1,18,25,18z"/>'
  }
})
